import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.037.519a4.296 4.296 0 014.296 4.296v2.317a6.944 6.944 0 11-8.593-.03V4.816A4.296 4.296 0 0110.038.519zm2.593 5.618a6.925 6.925 0 00-2.612-.507c-.909 0-1.778.175-2.574.492V4.815a2.593 2.593 0 115.186 0v1.322zm-1.704 7.05A1.72 1.72 0 0010.019 10a1.722 1.722 0 00-.908 3.186v1.944a.907.907 0 001.815 0v-1.944z"
        fill="#000"
        fillOpacity={0.5}
      />
    </Svg>
  );
}

export default SvgComponent;
